export default __webpack_public_path__ + "static/media/27.dac7565b.svg";